import actionTypes from "../actions/actionTypes";

const initialState = {
  preLogin: null,
  preLoginLoading: false,
  login: null,
  loginLoading: false,
  lastLoginTime: null,
  requestNewLoader: false,
  changePasswordLoader: false,
};

const loginReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.loginTypes.PRE_LOGIN:
      return { ...state, preLogin: payload };
    case actionTypes.loginTypes.SET_PRE_LOGIN_LOADER:
      return { ...state, preLoginLoading: payload };
    case actionTypes.loginTypes.LOGIN:
      return { ...state, login: payload };
    case actionTypes.loginTypes.SET_LOGIN_LOADER:
      return { ...state, loginLoading: payload };
    case actionTypes.loginTypes.SET_REQUEST_NEW_PASSWORD_LOADER:
      return { ...state, requestNewLoader: payload };
    case actionTypes.loginTypes.SET_CHANGE_PASSWORD_LOADER:
      return { ...state, changePasswordLoader: payload };
    case actionTypes.loginTypes.LAST_LOGIN_TIME:
      return { ...state, lastLoginTime: payload };
    default:
      return state;
  }
};

export default loginReducer;
